import { type FC } from 'react';
import {
  UiStack,
  type UiStackProps,
  uiStyles,
} from '@/lib/ui';

export interface CardGroupItemProps extends UiStackProps {
}

export const CardGroupItem: FC<CardGroupItemProps> = ({
  ...props
}) => {
  return (
    <UiStack
      borderRadius={uiStyles.borderRadius}
      borderWidth={'1px'}
      borderColor={'gray.300'}
      borderStyle={'solid'}
      {...props}
    />
  );
};

export default CardGroupItem;
